import './ApplePay/Main'
import './Client/Main';
import './DataCollector/Main';
import './HostedField/Main';
import './Paypal/Main';
import './ThreeDSecure/ThreeDSecure';
